// src/config/index.js
import { HarmCategory, HarmBlockThreshold } from "@google/generative-ai";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://practap.aroza-api.com.ng";

export const OBJECT_BASE_URL =
  process.env.OBJECT_BASE_URL ||
  "https://cloudflare-b2.smartbrainsvisual.workers.dev/";

export const DEFAULT_GEMINI_MODEL = "gemini-2.0-flash-exp";
export const TOKEN_KEY = "authToken"; // Key for storing token in localStorage
export const USER_KEY = "authUser"; // Key for storing user data in localStorage
export const GEMINI_SAFETY_SETTINGS = [
  {
    category: HarmCategory.HARM_CATEGORY_HARASSMENT,
    threshold: HarmBlockThreshold.BLOCK_MEDIUM_AND_ABOVE,
  },
  {
    category: HarmCategory.HARM_CATEGORY_HATE_SPEECH,
    threshold: HarmBlockThreshold.BLOCK_MEDIUM_AND_ABOVE,
  },
  {
    category: HarmCategory.HARM_CATEGORY_SEXUALLY_EXPLICIT,
    threshold: HarmBlockThreshold.BLOCK_MEDIUM_AND_ABOVE,
  },
  {
    category: HarmCategory.HARM_CATEGORY_DANGEROUS_CONTENT,
    threshold: HarmBlockThreshold.BLOCK_MEDIUM_AND_ABOVE,
  },
];

export const TRANSCRIPTION_RESPONSE_SCHEMA = {
  type: "object",
  properties: {
    transcription: { type: "string" },
  },
  required: ["transcription"],
};
